// extracted by mini-css-extract-plugin
export default {"feature-flag-form":"feature-flag-form_fBUoA"};